
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AuthAPI } from "../api/AuthAPI";

const VerifyOtp = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [email, setEmail] = useState(location.state?.email || "");
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!email || !otp) return setError("Please enter email and OTP.");

    try {
      setLoading(true);

      const response = await AuthAPI.verityotp({ email, otp });

      const resetToken = response?.data?.reset_token;

      if (!resetToken) {
        return setError("Something went wrong, no reset token received.");
      }

      localStorage.setItem("resetToken", resetToken);
      localStorage.setItem("resetEmail", email);

      navigate("/reset-password", { replace: true });

    } catch (err) {
      setError(err?.response?.data?.message || "Invalid OTP. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
  <div
    className="min-h-screen flex items-center justify-center bg-cover bg-center"
    style={{
      backgroundImage:
        'url("https://confidays.com/wp-content/uploads/2022/03/M2.png")',
    }}
  >
    <div className="bg-white rounded-xl shadow-lg w-full max-w-sm p-6">
      <h2 className="text-xl font-bold text-center mb-2">
        Verify OTP
      </h2>

      <p className="text-sm text-gray-600 text-center mb-4">
        Enter the OTP sent to your email
      </p>

      <form onSubmit={handleSubmit}>
        {/* Email */}
        <label className="block text-sm font-medium mb-1">
          Email address*
        </label>
        <input
          type="email"
          value={email}
          readOnly
          className="w-full border rounded-md px-3 py-2 mb-3 text-sm bg-gray-100"
        />

        {/* OTP */}
        <label className="block text-sm font-medium mb-1">
          OTP*
        </label>
        <input
          type="text"
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
          className="w-full border rounded-md px-3 py-2 mb-3 text-sm"
          required
        />

        {error && (
          <p className="text-red-500 text-xs text-center mb-2">
            {error}
          </p>
        )}

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-blue-900 hover:bg-blue-800 text-white py-2 rounded-md text-sm font-medium"
        >
          {loading ? "Verifying..." : "Verify →"}
        </button>
      </form>
    </div>
  </div>
);

};

export default VerifyOtp;
